import React from 'react';
import { useResolution } from '../../contexts/ResolutionContext';
import YearTabs from './YearTabs';
import ResolutionList from './ResolutionList';
import ProgressSummary from './ProgressSummary';

const ResolutionDashboard = ({ onDecryptResolution }) => {
	const {
		// Data from context
		resolutionsByYear,
		availableYears,
		activeYear,
		progress,

		// Functions from context
		setActiveYear,
		getCurrentResolutions,
		isUpdateAllowed,
		isAddAllowed,
		isDeleteAllowed,
		updateResolution,
		deleteResolution,

		// UI state
		isUpdating,
	} = useResolution();

	const currentResolutions = getCurrentResolutions();

	if (!currentResolutions || currentResolutions.length === 0) {
		let message = '';
		const now = new Date();
		const currentYear = now.getFullYear();
		const currentMonth = now.getMonth() + 1;
		if (activeYear === currentYear && (currentMonth === 1 || currentMonth >= 10)) {
			message = 'You can add new resolutions for this year!';
		} else {
			message = 'Check back during October 1st - January 31st to add new resolutions.';
		}
		return (
			<div className='text-center py-12'>
				<div className='mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4'>
					<span className='text-4xl text-gray-400'>🎯</span>
				</div>
				<h3 className='text-lg font-medium text-gray-900 mb-2'>No resolutions yet</h3>
				<p className='text-gray-600 text-sm max-w-sm mx-auto'>
					You don't have any resolutions for {activeYear}. <br />
					{message}
				</p>
			</div>
		);
	}

	return (
		<div>
			{/* Year Tabs */}
			<YearTabs
				availableYears={availableYears}
				activeYear={activeYear}
				onYearChange={setActiveYear}
				resolutionsByYear={resolutionsByYear}
			/>

			{/* Progress Summary - moved above resolution list */}
			<ProgressSummary resolutions={currentResolutions} progress={progress} />

			{/* Resolution List */}
			<ResolutionList
				resolutions={currentResolutions}
				activeYear={activeYear}
				isUpdateAllowed={isUpdateAllowed}
				isAddAllowed={isAddAllowed}
				isDeleteAllowed={isDeleteAllowed}
				isUpdating={isUpdating}
				onUpdateResolution={updateResolution}
				onDeleteResolution={deleteResolution}
				onDecryptResolution={onDecryptResolution}
			/>
		</div>
	);
};

export default ResolutionDashboard;
